import React, { useEffect, useState } from 'react';
import { Dialog } from '@material-ui/core';
import styled from 'styled-components';
import Magnifier from '../../../Magnifier';
const ImageWrapper = styled.div `
    margin: auto;
`;
const StyledDialog = styled(Dialog) `
    > div > div {
        height: calc(100% - 64px);
    }
`;
const ImageModal = ({ src, alt, open, initialWidth, onClose }) => {
    const [width, setWidth] = useState(initialWidth);
    useEffect(() => {
        setWidth(initialWidth);
    }, [initialWidth]);
    const zoomOut = () => {
        setWidth((prev) => (prev !== null && prev !== void 0 ? prev : 0) - 50);
    };
    const zoomIn = () => {
        setWidth((prev) => (prev !== null && prev !== void 0 ? prev : 0) + 50);
    };
    return (React.createElement(StyledDialog, { fullWidth: true, maxWidth: "xl", open: open, onClose: onClose },
        React.createElement(Magnifier, { zoomOut: zoomOut, zoomIn: zoomIn }),
        React.createElement(ImageWrapper, null,
            React.createElement("img", { height: "auto", width: width, src: src !== null && src !== void 0 ? src : undefined, alt: alt }))));
};
export default ImageModal;
//# sourceMappingURL=ImageModal.js.map